<template>
  <div>

    <error-modal
      v-if="hasError"
      @buttonClicked="onModalCloseClicked"
      title="ظاهراً مشکلی پیش آمده است. مجدداً تلاش نمائید."
      buttonTitle="تلاش مجدد"
    ></error-modal>

    <div class="container-fluid margin_60">
      <div class="row">
        <aside class="col-lg-3">
          <PdkFlightItinerary :itienary="itinerary" />
          <div id="filters_col">
            <a
              class="title-tools"
              data-toggle="collapse"
              href="#collapseFilters"
              aria-expanded="false"
              aria-controls="collapseFilters"
              id="filters_col_bt"
            >
              <i class="icon icon-money"></i>فیلتر قیمت بلیط
            </a>
            <div class="collapse shwo show" id="collapseFilters">
              <PdkRangeSlider
                @onChange="onChangePriceRange"
                @onStart="onStartPriceRange"
                type="double"
                :min="20"
                :max="10000000"
                :from="0"
                :to="10000000"
                :step="10000"
              ></PdkRangeSlider>
              <hr />
              <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-plane filter-icon"></i>فیلتر خطوط هواپیمایی
                </a>
                <PdkAirlineFilter :airlines="airlines" />
              </div>
              <div class="filter_type">
                <hr />
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-ticket-2 filter-icon"></i>فیلتر نوع بلیط
                </a>

                <ul>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                      title="اکونومی"
                    />
                  </li>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                      title="بیزینس"
                    />
                  </li>
                </ul>
              </div>

              <hr />
              <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-back-in-time filter-icon"></i>فیلتر زمان پرواز
                </a>
                <PdkRangeSlider @onChange="onChangeTimeRange" type="double" :values="timeArray"></PdkRangeSlider>
              </div>
            </div>
            <!--End collapse -->
          </div>
          <!--End filters col-->
          <div class="box_style_2">
            <i class="icon_set_1_icon-57"></i>
            <h4>
              به کمک
              <span>نیاز دارید؟</span>
            </h4>
            <a href="tel://02144631360" class="phone">021-44631360-5</a>
            <a href="tel://02144631360" class="phone">09045425792</a>
          </div>
        </aside>
        <!--End aside -->

        <div class="col-lg-9">
          <PdkFlightNotFound  @notFoundAction="onNotFoundAction" v-if="isNotFoundResult" />

          <div v-if="isNotFoundResult == false">
            <PdkFlightSort @sortBy="sortFlightBy"></PdkFlightSort>
            <!--/tools -->
            <div v-for="(flight, index) in filteredAvailFlights" :key="index">
              <PdkFlightAvail :availableFlight="flight"></PdkFlightAvail>
            </div>

            <hr />

            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active">
                  <span class="page-link">
                    1
                    <span class="sr-only">(current)</span>
                  </span>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">2</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">3</a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
            <!-- end pagination-->
          </div>
        </div>
        <!-- End col lg-9 -->
      </div>
      <!-- End row -->
    </div>
  </div>
</template>

<style>
/* .icon {
  padding-left: 4px;
  font-size: 15px;
} */

.title-tools {
  margin-bottom: 10px;
}
</style>

<script>
import CheckBox from "@/components/PdkCheckBox";
import PdkRangeSlider from "@/components/PdkRange";
import PdkFlightSort from "@/components/flight/FlightSort";
import PdkFlightAvail from "@/components/flight/FlightAvail";
import PdkAirlineFilter from "@/components/shared/AirlineFilter";
import PdkFlightNotFound from "@/components/flight/FlightNotFound";
import PdkFlightItinerary from "@/components/shared/FlightItinerary";
import date from "@/utils/date";

require("linqjs");

export default {
  name: "FlightAvailList",
  components: {
    PdkFlightAvail,
    PdkRangeSlider,
    PdkFlightSort,
    PdkAirlineFilter,
    "pdk-ckeckbox": CheckBox,
    PdkFlightItinerary,
    PdkFlightNotFound,
  },

  data: () => ({
    isResultNotFound: false,
    availFlights: [],
    filteredAvailFlights: [],
    airlines: [],
    ascending: false,
    sortType: "",
    itinerary: {
      originCity: "تهران",
      destinationCity: "شیراز",
      airLineName: "ZV",
      origin: "THR",
      destination: "SYZ",
      departureDateTime: "1399/05/29",
      adultQty: 1,
      infantQty: 1,
      childQty: 0,
    },

    payLoad: {
      origin: "THR",
      destination: "SYZ",
      departureDateTime: "1399/05/25",
      adultQty: 1,
      infantQty: 1,
      childQty: 0,
    },
  }),

  methods: {
    // selectFlight(roomId) {
    //   this.$store.dispatch("SelectFlight", { hotelId: 4, roomId });
    // },

    async getAvailFligh(payload) {
      this.availFlights = await this.$store.dispatch(
        "GetAvailFlights",
        payload
      );

      this.filteredAvailFlights = this.availFlights;
      this.airlines = this.availFlights.groupBy((t) => t.airLineName);
    },

    async sortFlightBy(sort) {

      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }
      var ascending = this.ascending;

      this.filteredAvailFlights.sort(function (a, b) {
        if (a[sort] > b[sort]) {
          return ascending ? 1 : -1;
        } else if (a[sort] < b[sort]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    async onStartPriceRange(event) {
    },
    async onChangePriceRange(event) {
      this.filteredAvailFlights = this.availFlights.where(
        (p) => p.totalAdultFare >= event.from && p.totalAdultFare <= event.to
      );
    },
    async onChangeTimeRange(event) {
      this.filteredAvailFlights = this.availFlights.where(
        (p) =>
          p.departureTime >= event.fromValue && p.departureTime <= event.toValue
      );
    },
    async onNotFoundAction(event) {
      switch (event) {
        case "oneDayLater":
          this.payLoad.departureDateTime = date.AddPersian(
            this.itinerary.departureDateTime,
            "day",
            1
          );
          this.itinerary.departureDateTime = this.payLoad.departureDateTime;
          this.getAvailFligh(this.payLoad);
          break;
        case "oneDayBefore":
          this.payLoad.departureDateTime = date.AddPersian(
            this.itinerary.departureDateTime,
            "day",
            -1
          );
          this.itinerary.departureDateTime = this.payLoad.departureDateTime;
          this.getAvailFligh(this.payLoad);
          break;
        case "changeSearch":
          break;
        default:
          break;
      }


    },
  },

  mounted: function () {
    this.getAvailFligh(this.payLoad);
  },

  computed: {
    timeArray() {
      var result = [];

      for (var i = 0; i < 24; i++) {
        if (i < 10) {
          result.push("0" + i + ":00");
        } else {
          result.push(i + ":00");
        }
      }
      result.push("23:59");
      return result;
    },
    
    isNotFoundResult() {
      return this.$store.getters.isNotFoundResult;
    },
    hasError() {
      return this.$store.getters.error;
    },
  },
};
</script>